<main class="restore-clinic-page">
  <div class="content-wrapper">
    @if (store.status() === status.Loading) {
      <mat-spinner diameter="48"></mat-spinner>
    }

    @if (store.status() === status.Error) {
      <div class="error-box">
        <span class="error-icon">&#9888;</span>
        <p class="error-message">{{ store.error() }}</p>
      </div>
    }
  </div>
</main>
